export default () => {
  const width = document.body.clientWidth;
  const handleClick = (props) => {
    if (props?.url) {
      window.open(props?.url, "_blank");
    }
  };
  return { width, handleClick };
};
